import React from 'react'
import Button from '../Button'
import './footerSection.css'
import illustrationFooterSectionM from '../../images/illustration-footer-m.svg'
import illustrationFooterSectionD from '../../images/illustration-footer-d.svg'
import footerArrowLineM from '../../images/footer-arrow-line-m.svg'
import footerArrowLineD from '../../images/footer-arrow-line-d.svg'
import downloadIcon from '../../images/download-icon.svg'
import { AppModalContext } from "../../components/AppModal/context";
import ContactForm from "../../components/ContactForm";

const FooterSection = () => {
  const { handleModal } = React.useContext(AppModalContext);

  return (
    <section className="section section-footer section--light">
      <div className="section-footer-content container-inner">
        <div className="heading">
          Fii șofer Neo și ești plătit și când mergi pe gol.
        </div>
        <div className="py-2"></div>
        <ul className="points">
          <li className="point">
            Cel mai bun tarif/km disponibil în piață
          </li>
          <li className="point">
            Gradul de ocupare al mașinii este garantat 100%. Ești plătit când mergi pe gol
          </li>
        </ul>
        <div className="btns-wrapper">
          <div className="btn-wrapper">
            <Button 
              onClick={() => handleModal(<ContactForm buttonType="primary" formType="Vreau să devin șofer"/>)}
              type="primary">
                Vreau să devin șofer
            </Button>
          </div>
          <div className="btn-wrapper">
            <Button 
              onClick={() => handleModal(<ContactForm buttonType="primary" formType="Descarcă Neo.Driver"/>)}
              type="primary" 
              icon={downloadIcon}>
                Descarcă Neo.Driver
            </Button>
          </div>
        </div>
      </div>
      <img className="illustration-m w-full" src={illustrationFooterSectionM}/>
      <img className="illustration-d w-full" src={illustrationFooterSectionD}/>
    </section>
  )
}

export default FooterSection